import React from 'react'
import Home from '../Components/HomePage/Home/Home'
import ActiveProjects from '../Components/HomePage/ActiveProjects/ActiveProjects'
import Stats from '../Components/HomePage/Stats/Stats'
import WhyGemco from '../Components/HomePage/WhyGemco/WhyGemco'
import Oursectors from '../Components/HomePage/OurSectors/Oursectors'
import Featured from '../Components/HomePage/FeaturedProjects/Featured'
import Strip from '../Components/HomePage/Strip/Strip'
import Contact from '../Components/HomePage/Contact/Contact'

const HomePage = () => {
  return (
    <>
        <Home />
        {/* <ActiveProjects /> */}
        <Stats />
        <WhyGemco />
        {/* <Featured /> */}
        <Strip />
        <Contact />
    </>
  )
}

export default HomePage